import api from './api';
import { HonoraryNote, HonoraryNoteLine } from '../../details/honorary-note/types';

const honoraryUrl = '/honorary-notes';

export function getHonoraryNote(instructionId: number) {
  return api.get(`${honoraryUrl}/${instructionId}`).catch(err => {
    return err;
  });
}

export function getHonoraryNoteList(nstructionId: number) {
  return api.get(`${honoraryUrl}/list/${nstructionId}`).catch(err => {
    return err;
  });
}

export function getHonoraryNoteTypeCodes() {
  return api.get(`${honoraryUrl}/typecodes`).catch(err => {
    return err;
  });
}

export function saveHonoraryNote(data: HonoraryNote) {
  return api.post(`${honoraryUrl}/save`, {
    data: data
  }).catch(err => {
    console.error(err);
    return err;
  });
}

export function saveHonoraryNoteLine(data: HonoraryNoteLine) {
  return api.post(`${honoraryUrl}/save-line`, {
    data: data
  }).catch(err => {
    console.error(err);
    return err;
  });
}

export function deleteHonoraryNote(honoraryNoteId: number) {
  return api.delete(`${honoraryUrl}/${honoraryNoteId}`).catch(err => {
    console.error(err);
    return err;
  });
}

export function deleteHonoraryNoteLine(honoraryNoteLineId: number) {
  return api.delete(`${honoraryUrl}/delete-line/${honoraryNoteLineId}`).catch(err => {
    console.error(err);
    return err;
  });
}
